import { useContext, useEffect, useRef, useState } from "react";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { Box, Typography } from "@mui/material";
import { GlobalContext } from "../../context/globalContext";
import { fakeTableList, schema, stepperData } from "./parts";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import { httpIAPI_CON006, httpIAPI_CON013 } from "./api/request";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  formClassCorp,
  FormKbn,
  NoOwnerReason,
} from "../../assets/data/Constants";
import "./_style.scss";
import _ from "lodash";

/**
 * SCRC050009 契約解除（経営者でなくなった）入力内容確認
 * @return SCRC050009 契約解除（経営者でなくなった）入力内容確認
 */
const SCRC050009 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateFakeTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);
  // ユーザータイプ
  const userType = state.authInfo?.userType;
  // ユーザタイプが機構か
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  // ダイアログ開閉状態
  const [open, setOpen] = useState(false);
  const [tempStep, setTempStep] = useState<number>();
  const [showButton, setShowButton] = useState(true);
  const applyId = location.state?.applyId;

  // 初期化
  const handleInit = async () => {
    let tempStep = businessState.job_02?.tempSaveStep;
    let resArr = stateFakeTableList.current;

    // 契約者（法人）名
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    if (isUserTypeKiko) {
      contractorName.showLine = true;
      contractorName.text = `${businessState.common?.contractorNo}:${businessState.common?.contractorName}`;
    }

    // 経営者でなくなった年月日
    let managerDateOfDisappearance = resArr.find(
      (item) => item.keyword === "managerDateOfDisappearance"
    )!;
    // 経営者でなくなった理由
    let managerReasonOfDisappearance = resArr.find(
      (item) => item.keyword === "managerReasonOfDisappearance"
    )!;
    // 理由
    let reason = resArr.find((item) => item.keyword === "reason")!;
    // 廃止・休止が確認できる書類
    let downloadLink = resArr.find((item) => item.keyword === "downloadLink")!;
    // 社会福祉施設等、特定介護保険施設等又は申出施設等の名称、被共済職員数
    let facilityName = resArr.find((item) => item.keyword === "facilityName")!;
    // 変更後の共済契約者番号
    let numberAfterChange = resArr.find(
      (item) => item.keyword === "numberAfterChange"
    )!;
    // 変更後の共済契約者名
    let nameAfterChange = resArr.find(
      (item) => item.keyword === "nameAfterChange"
    )!;

    if (applyId) {
      const res = await httpIAPI_CON006({
        applyId: applyId,
      });
      if (res.resultCd === "I0000") {
        managerDateOfDisappearance.text = res.noOwnerDate;

        managerReasonOfDisappearance.node = (
          <Box className="tkAdjustCenter">
            <Box className="tkSpaceRight">
              <Typography>{res.noOwnerReason}</Typography>
            </Box>
            <Typography>
              {TkGetCode(NoOwnerReason, res.noOwnerReason)}
            </Typography>
          </Box>
        );

        reason.text = res.reason;

        let targetFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["法人書類"] &&
            item.formClass === formClassCorp["廃止・休止が確認できる書類の添付"]
        );
        downloadLink.base64filedata = targetFile?.fileBase64;
        downloadLink.dataname = targetFile?.fileName;

        facilityName.node = (
          <Box>
            {res.facilityList?.map((item: any) => (
              <Box className="tkAdjustCenter" key={item.facilityNo}>
                <Box className="tkSpaceRight">
                  <Typography>{`${item.facilityNo}:${item.facilityName}`}</Typography>
                </Box>
                <Typography>{`${item.maStaffNum}人`}</Typography>
              </Box>
            ))}
          </Box>
        );
        numberAfterChange.text = res.aContractorNo;
        nameAfterChange.text = res.aCorpName;
        if (res.latestApplyStatus !== "00" && res.latestApplyStatus !== "16") {
          tempStep = 4;
          setShowButton(false);
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } else {
      managerDateOfDisappearance.text = businessState.job_02?.noOwnerDate;

      managerReasonOfDisappearance.node = (
        <Box className="tkAdjustCenter">
          <Box className="tkSpaceRight">
            <Typography>{businessState.job_02?.noOwnerReason}</Typography>
          </Box>
          <Typography>
            {TkGetCode(NoOwnerReason, businessState.job_02?.noOwnerReason)}
          </Typography>
        </Box>
      );

      reason.text = businessState.job_02?.reason;

      downloadLink.base64filedata = businessState.job_02?.fileBase64;
      downloadLink.dataname = businessState.job_02?.fileName;
      downloadLink.downloadBase64 = true;

      facilityName.node = (
        <Box>
          {location.state?.facilityList?.map((item: any) => (
            <Box className="tkAdjustCenter" key={item.facilityNo}>
              <Box className="tkSpaceRight">
                <Typography>{`${item.facilityNo}:${item.facilityName}`}</Typography>
              </Box>
              <Typography>{`${item.staffNum}人`}</Typography>
            </Box>
          ))}
        </Box>
      );

      numberAfterChange.text = businessState.job_02?.aContractorNo;

      nameAfterChange.text = businessState.job_02?.aCorpName;
    }
    setTempStep(tempStep);
    setStateFakeTableList([...resArr]);
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //「機構へ提出する」、「申請」ボタン用イベント
  const onCheckAndSubmit = () => {
    setOpen(true);
  };

  const handleSubmit = async (date?: any) => {
    try {
      // 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届更新API実行
      const res = await httpIAPI_CON013({
        applyId: businessState.job_02?.applyId,
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo!
            : state.authInfo?.contractorNo!,
        noOwnerDate: businessState.job_02?.noOwnerDate,
        noOwnerReason: businessState.job_02?.noOwnerReason,
        reason: businessState.job_02?.reason,
        formList: [
          {
            serialNo: 1,
            facilityNo: "",
            staffNo: "",
            formKbn: "3",
            formClass: "6",
            fileName: businessState.job_02?.fileName,
            fileBase64: businessState.job_02?.fileBase64,
          },
        ],
        aContractorNo: businessState.job_02?.aContractorNo,
        aCorpName: businessState.job_02?.aCorpName,
        facilityList: location.state?.facilityList?.map((item: any) => ({
          facilityNo: item.facilityNo,
          maStaffNum: item.staffNum,
        })),
        receptionDate: date,
        screenId: "SCRC050009",
      });

      if (res?.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
        setOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC050009PageForTest" className="SCRC050009">
      <TkStepper steps={stepperData} activeStep={2} savaStep={tempStep} />

      <TkFakeTable
        ruleSchema={schema}
        list={stateTableList}
        submitButtonText={isUserTypeKiko ? "申請" : "機構へ提出する"}
        showButton={showButton}
        onCheckAndSubmit={() => onCheckAndSubmit()}
        buttonGroup={<TkBackButton />}
      />

      {isUserTypeKiko ? (
        <TkDateDialog
          open={open}
          onOky={handleSubmit}
          onCancel={() => setOpen(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="　申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={open}
          onOky={handleSubmit}
          onCancel={() => setOpen(false)}
          title="確認（機構へ提出します）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC050009;
